// /api/table/:id/close
import { api } from '../api'

export const closeTable = async (tableId: string): Promise<{}> =>
  await api().url(`/api/table/${tableId}/close`).delete().json()
